export const SET_PROFILE = 'SET_PROFILE';
export const CHK_ACC_START = 'CHK_ACC_START';
export const CHK_ACC_SUCCESS = 'CHK_ACC_SUCCESS';
export const CHK_ACC_FAILURE = 'CHK_ACC_FAILURE';
export const ERROR = 'ERROR';
export const INIT = 'INIT';
export const LOADING ='LOADING';
export const SUCCESS = 'SUCCESS';
export const FETCH_CAPB_START = 'FETCH_CAPB_START';
export const FETCH_CAPB_SUCCESS = 'FETCH_CAPB_SUCCESS';
export const FETCH_CAPB_FAIL = 'FETCH_CAPB_FAIL';
export const SET_BU = 'SET_BU'

// User Preferences Action Types
export const FETCH_USER_PREFERENCE_START = 'FETCH_USER_PREFERENCE_START';
export const FETCH_USER_PREFERENCE_SUCCESS = 'FETCH_USER_PREFERENCE_SUCCESS';
export const FETCH_USER_PREFERENCE_FAIL = 'FETCH_USER_PREFERENCE_FAIL';

export const SAVE_USER_PREFERENCE_START = 'SAVE_USER_PREFERENCE_START';
export const SAVE_USER_PREFERENCE_SUCCESS = 'SAVE_USER_PREFERENCE_SUCCESS';
export const SAVE_USER_PREFERENCE_FAIL = 'SAVE_USER_PREFERENCE_FAIL';